export default __webpack_public_path__ + "static/media/ga4-bigquery-3.0429443a.png";